/**
 * Interface representing the result of password validation checks
 */
export interface PasswordValidationResult {
  /** Whether the password meets the minimum length requirement (>=7) */
  lengthValid: boolean;
  /** Whether the password meets the maximum length requirement (<=40) */
  maxLength: boolean;
  /** Whether the password contains at least one capital letter */
  capitalLetter: boolean;
  /** Whether the password contains at least one lowercase letter */
  lowercaseLetter: boolean;
  /** Whether the password contains special characters */
  specialCharacters: boolean;
  /** Whether the password contains numbers */
  containNumbers: boolean;
  /** Whether the password contains no whitespace */
  noWhitespace: boolean;
  /** Whether all password requirements are met */
  isValid: boolean;
}

/**
 * Validation message constants used in Zod schema validation
 */
export const VALIDATION_MESSAGES = {
  /** Whether the password meets the minimum length requirement (>=7) */
  lengthValid: 'lengthValid',
  /** Whether the password meets the maximum length requirement (<=40) */
  maxLength: 'maxLength',
  /** Whether the password contains at least one capital letter */
  capitalLetter: 'capitalLetter',
  /** Whether the password contains at least one lowercase letter */
  lowercaseLetter: 'lowercaseLetter',
  /** Whether the password contains special characters */
  specialCharacters: 'specialCharacters',
  /** Whether the password contains numbers */
  containNumbers: 'containNumbers',
  /** Whether the password contains no whitespace */
  noWhitespace: 'noWhitespace',
} as const;

export type ValidationMessage = keyof typeof VALIDATION_MESSAGES;
